import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import Cookies from 'js-cookie';
import useUserDetails from '../../hooks/useUserDetails';

const BreadCrumb = ({ title, pageTitle }) => {

    const { COMPANY_NAME } = useUserDetails();

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0"></h4>

                        <p className="mb-sm-0 fw-bold">{COMPANY_NAME}</p>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/dashboard">{pageTitle}</Link></li>
                                <li className="breadcrumb-item active">{title}</li>
                            </ol>
                        </div>

                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;